/**
 * @file XML HTTP Request
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/xhr
 */

import { Config } from './config';

/* eslint-disable no-magic-numbers */
var create = typeof window !== 'undefined' && window.XMLHttpRequest ? function () {
  return new XMLHttpRequest();
}
// eslint-disable-next-line no-undef
: function () {
  return new ActiveXObject('MSXML2.XMLHTTP');
};
export default function xhr(url, callback) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
  var xhr = create();
  xhr.open(method.toUpperCase(), url, true);
  xhr.timeout = Config.TIMEOUT || 0;
  xhr.onreadystatechange = function () {
    if (xhr.readyState !== 4) {
      return;
    }
    var status = xhr.status === 1223 ? 204 : xhr.status;
    xhr.onreadystatechange = new Function();
    xhr = null;
    callback(status >= 200 && status <= 300);
  };
  xhr.send();
}